import { isNonEmptyArray } from '../utils/checks'

export const generateCommaSeparatedListEndingWithAnd = (array) => {
  if (!isNonEmptyArray(array)) return ''
  if (array.length === 1) return array[0]
  if (array.length === 2) return `${array[0]} and ${array[1]}`
  return `${array.slice(0, -1).join(', ')} and ${array[array.length - 1]}`
}
